webpackJsonp([43369700788870],{

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aos = __webpack_require__(30);
	
	var _aos2 = _interopRequireDefault(_aos);
	
	var _reactRouterDom = __webpack_require__(9);
	
	var _Map = __webpack_require__(169);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var center = { lat: 12.9288512, lng: 77.6274287 };
	var mapProps = {
	    options: {
	        center: center,
	        zoom: 18
	    },
	    onMount: function onMount(map) {
	        new window.google.maps.Marker({
	            position: center,
	            map: map,
	            title: 'Hubler'
	        });
	    }
	};
	
	var ContactUs = function (_Component) {
	    _inherits(ContactUs, _Component);
	
	    function ContactUs() {
	        _classCallCheck(this, ContactUs);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ContactUs.prototype.componentDidMount = function componentDidMount() {
	        this.aos = _aos2.default;
	        this.aos.init({
	            duration: 1500,
	            once: true
	        });
	    };
	
	    ContactUs.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'contact-us-main-page' },
	            _react2.default.createElement(
	                'div',
	                { className: 'heading' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'contact' },
	                    'Contact Us'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'inquiry' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'sales-inquiry inquiry-cls' },
	                    _react2.default.createElement('div', { className: 'image' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'head' },
	                        'Sales Inquiry'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Reach out to our Sales team directly for immediate assistance with all sales-related inquiries.'
	                    ),
	                    _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        { to: '/sales' },
	                        'Sales Inquiry'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'customer-support inquiry-cls' },
	                    _react2.default.createElement('div', { className: 'image' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'head' },
	                        'Customer Support'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Get in touch with customer support for assistance with your Hubler product queries.'
	                    ),
	                    _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        { to: '/customerSupport' },
	                        'Customer Support'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'company-info-address' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'company-info-address-cls' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'address-cls' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'address-one address-info' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'head' },
	                                'India'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'address' },
	                                'Hubbler Private Limited'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'address' },
	                                'No.87, Anugraha Building, 4th Floor,'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'address' },
	                                '7th Cross, 4th B Block,'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'address' },
	                                'Koramangala, Bangalore - 560034'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'address' },
	                                'Landline: +91 80 4200 1415'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'address email' },
	                                'Email:',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'mailto: connect@hubbler.mobi' },
	                                    'connect@hubbler.mobi'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'address-two address-info' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'head' },
	                                'USA'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'address' },
	                                'Hubler LLC'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'address' },
	                                '8 The Green, Suite R, Dover'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'address' },
	                                'Zip Code 19901'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'address email' },
	                                'Email:',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'mailto: connect@hubbler.mobi' },
	                                    'connect@hubbler.mobi'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'map' },
	                        _react2.default.createElement(_Map2.default, _extends({ id: 'contactMap' }, mapProps))
	                    )
	                )
	            )
	        );
	    };
	
	    return ContactUs;
	}(_react.Component);
	
	exports.default = ContactUs;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-us-js-3b3b0d0543bd48e53517.js